<template>
    <header class="header-global">
        <nav id="navbar-main" class="navbar navbar-main navbar-expand-lg navbar-transparent navbar-light">
        <div class="container">
            <router-link to="/" class="navbar-brand mr-lg-5">
            <img src="https://services.payremind.com/assets/images/favicon.png" alt="Pay Reminder">
            </router-link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar_global" aria-controls="navbar_global" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
            </button>
            <div class="navbar-collapse collapse" id="navbar_global">
            <div class="navbar-collapse-header">
                <div class="row">
                <div class="col-6 collapse-brand">
                    <router-link to="/">
                    <img src="https://services.payremind.com/assets/images/favicon.png">
                    </router-link>
                </div>
                <div class="col-6 collapse-close">
                    <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbar_global" aria-controls="navbar_global" aria-expanded="false" aria-label="Toggle navigation">
                    <span></span>
                    <span></span>
                    </button>
                </div>
                </div>
            </div>
            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <li class="nav-item">
                <router-link to="/" class="nav-link" role="button">
                    <i class="ni ni-ui-04 d-lg-none"></i>
                    <span class="nav-link-inner--text">หน้าแรก</span>
                </router-link>
                </li>
                <li class="nav-item dropdown">
                <a href="#" class="nav-link" data-toggle="dropdown" role="button">
                    <i class="ni ni-ui-04 d-lg-none"></i>
                    <span class="nav-link-inner--text">เกี่ยวกับ</span>
                </a>
                <div class="dropdown-menu dropdown-menu-xl">
                    <div class="dropdown-menu-inner">
                    <a href="#about" class="media d-flex align-items-center" data-toggle="scroll">
                        <div class="icon icon-shape bg-gradient-info rounded-circle text-white">
                        <i class="ni ni-spaceship"></i>
                        </div>
                        <div class="media-body ml-3">
                        <h6 class="heading text-info mb-md-1">ข้อมูล</h6>
                        <p class="description d-none d-md-inline-block mb-0">ที่มาหรือกว่าจะมาเป็นเรา Pay Reminder</p>
                        </div>
                    </a>
                    <a href="#award" class="media d-flex align-items-center" data-toggle="scroll">
                        <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                        <i class="ni ni-image"></i>
                        </div>
                        <div class="media-body ml-3">
                        <h5 class="heading text-primary mb-md-1">ผลงาน</h5>
                        <p class="description d-none d-md-inline-block mb-0">รวมประสบการณ์ของ Pay Reminder</p>
                        </div>
                    </a>
                    </div>
                </div>
                </li>
                <li class="nav-item dropdown">
                <a href="#" class="nav-link" data-toggle="dropdown" role="button">
                    <i class="ni ni-collection d-lg-none"></i>
                    <span class="nav-link-inner--text">ติดต่อ</span>
                </a>
                <div class="dropdown-menu">
                    <a href="#contact" class="dropdown-item" data-toggle="scroll"><i class="ni ni-support-16"></i>ช่องทางติดต่อ</a>
                    <a href="#developer" class="dropdown-item" data-toggle="scroll"><i class="ni ni-building"></i>ทีมงาน</a>
                </div>
                </li>
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                <a class="nav-link nav-link-icon" href="https://www.facebook.com/drafmatong" target="_blank" data-toggle="tooltip" title="Like us on Facebook">
                    <i class="fa fa-facebook-square"></i>
                    <span class="nav-link-inner--text d-lg-none">Facebook</span>
                </a>
                </li>
                
                <li v-if="!user.users_id" class="nav-item d-none d-lg-block ml-lg-4">
                    <a :href="linklinelogin" class="btn btn-neutral btn-icon">
                        <span class="btn-inner--icon">
                        <i class="ni ni-single-02 mr-2"></i>
                        </span>
                        <span class="nav-link-inner--text">เข้าใช้งาน</span>
                    </a>
                </li>

                <li v-else class="nav-item d-none d-lg-block ml-lg-4">
                    <router-link to="/user" class="btn btn-neutral btn-icon">
                        <span class="btn-inner--icon">
                        <i class="ni ni-single-02 mr-2"></i>
                        </span>
                        <span class="nav-link-inner--text">{{ user.users_name }} {{ user.users_lastname }}</span>
                    </router-link>
                </li>

            </ul>
            </div>
        </div>
        </nav>
    </header>
</template>

<script>
import UserStore from '@/stores/UserStore'
import router from "@/router";
export default {
  name: 'Header',
  components: {
    // HelloWorld
  },
  data(){
      return {
          user : [],
          linklinelogin:null,
      }
  },
  methods: {
    getUser: async function() {
      if(!localStorage.access_token) router.push('/')
      let optionts = {
        access_token : localStorage.access_token
      }      
      await UserStore.dispatch('getUser',optionts)
      // console.log(UserStore.state.user.user);
      // console.log(UserStore.state.user.status);
      if(UserStore.state.user.status == 200){
        this.user = UserStore.state.user.user;
      }else{
        router.push('/')
      }
    },
    LoadLinklinelogin: async function() {
      await UserStore.dispatch('getLoginLine')
      if(UserStore.state.lineloginline.status){
        this.linklinelogin = UserStore.state.lineloginline.url;
      }
    },
  },
  async mounted () {
    await this.LoadLinklinelogin()
    await this.getUser()
  },
}
</script>